<template>
    <footer class="footer">
        <div class="content has-text-centered">
            <p>
                <span>&copy; <strong>Tartu Ülikool/University of Tartu</strong> {{ new Date().getFullYear() }}</span>
            </p>
            <p>
                License: <a href="https://creativecommons.org/licenses/by-nc-sa/3.0/legalcode">CC BY NC SA 3.0</a>
            </p>
        </div>
    </footer>
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>